// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__Yvdyh","checkboxCol":"Table_checkboxCol__2ISeU","emailCol":"Table_emailCol__2CZmu","actionCol":"Table_actionCol__HBnm6"};